import './header.scss'

import React, { useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { itas_assicurazioni_de, itas_assicurazioni_it } from 'src/assets'
import { NAV_TO_LOGIN } from 'src/navigation'
import { shoot } from 'src/redux/actions'
import {
  select_customer,
  select_logged,
  select_login_token,
  select_outcome_logout,
  select_mobile_banner_active
} from 'src/redux/store'
import { get_language } from 'src/utils'
import DropDownButton from 'src/widgets/--deprecated/dropdown/dropdown'
import MobileMenu from 'src/widgets/--deprecated/header/mobile-menu/mobile-menu'

import Version from '../version/version'
import LanguageSelector from './language-selector/language-selector'
import Button from 'src/widgets/--deprecated/button/button'
import { ClassNames } from 'src/utils/--deprecated'
import { close_icon, itas_app_icon } from 'src/assets'

interface HeaderProps {
  name?: string;
  showBackdrop?: () => void;
  backdrop_open?: boolean;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // MOBILE BANNER
  const APPSTORE_URL = `https://apps.apple.com/${get_language() === "IT" ? 'it' : 'de'}/app/itas-assicurazioni/id6468985458`;
  const PLAYSTORE_URL = `https://play.google.com/store/apps/details?id=it.gruppoitas.superapp&hl=${get_language() === "IT" ? 'it' : 'de'}`;

  /**
   * Use State
   */
  const [mobile_menu_visible, set_mobile_menu_visible] = useState(false)
  const [is_mobile, set_is_mobile] = useState(window.innerWidth < 810)
  const [show_mobile_ad, set_show_mobile_ad] = useState(true)

  /**
   * Use Selector
   */
  const customer = useSelector(select_customer)
  const login_token = useSelector(select_login_token)
  const outcome_logout = useSelector(select_outcome_logout)
  const is_logged = useSelector(select_logged)
  const show_banner = useSelector(select_mobile_banner_active)

  const header_data: any = t('header', { returnObjects: true })

  // NO DELETE
  // const onClickBellHandler = () => {
  //   alert('Add link')
  // }

  const show_mobile_menu_handler = () => {
    !mobile_menu_visible
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = '')
    return set_mobile_menu_visible(!mobile_menu_visible)
  }

  const dropdown_item_handler = (id: string, link: string) => {
    if (id === 'logout_id') {
      dispatch(shoot.saga_logout({ bearer_token: login_token?.access_token }))
    } else {
      navigate(link)
    }
  }

  const handleAppDownloadUri = () => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isAndroid) {
      window.open(PLAYSTORE_URL);
    } else if (isIOS) {
      window.open(APPSTORE_URL);
    } else {
      window.alert("App download is only available for Android and iOS devices.");
    }
  };

  /**
   * Use effect
   */
  useEffect(() => {
    if (outcome_logout) {
      dispatch(shoot.reduce_outcome_logout())
      navigate(NAV_TO_LOGIN)
    }
  }, [outcome_logout])

  useEffect(() => {
    window.addEventListener(
      'resize',
      () => {
        const ismobile = window.innerWidth < 810
        if (ismobile !== is_mobile) {
          set_is_mobile(ismobile)
          set_mobile_menu_visible(false)
        }
        mobile_menu_visible
          ? (document.body.style.overflow = 'hidden')
          : (document.body.style.overflow = '')
      },
      false
    )
  }, [is_mobile])

  // Ask CMS to decide whether to show or not mobile app download banner
  useEffect(() => {
    if (!show_banner) {
      setTimeout(() => {
        dispatch(
          shoot.saga_resolve_communications_registration({ domain: 'HOM', subdomain: 'VBA' })
        )
      })
    }
  }, [])

  const desktop_form = (
    <header className="header-navbar">
      <div className="header-logo">
        <a href="https://www.gruppoitas.it/" target="_blank" rel="noreferrer">
          {get_language() === 'IT' ? (
            <Image src={itas_assicurazioni_it} width={128} height={40} />
          ) : (
            <Image src={itas_assicurazioni_de} width={128} height={40} />
          )}
        </a>
      </div>
      <nav className="header-nav">
        {is_logged ? (
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <div className="icon-person row align-items-center c-ffffff mr-2">
                <div className="w-100 text-center text-uppercase">
                  {customer?.personTypeCode === 'F'
                    ? `${customer?.name?.charAt(0)}${customer?.surname?.charAt(0)}`
                    : customer?.businessName?.substring(0, 2)}
                </div>
              </div>
              <div className="row mx-2">
                <div className="w-100 text-capitalize font-12-semibold">
                  {customer?.personTypeCode === 'F' ? customer?.name : customer?.businessName}
                </div>
                <div className="font-12 text-center c-7f7f7f">{`ID ${customer?.proClie}`}</div>
              </div>
            </div>

            <div
              className={`
          row pb-1 ${props?.backdrop_open ? 'header-border' : ''}`}
            >
              <DropDownButton
                title={t('header.menu_text')}
                navbar
                on_click_item_handler={dropdown_item_handler}
                menuData={header_data.menu_items}
                showBackdrop={props?.showBackdrop}
              />
            </div>
          </div>
        ) : null}
        {/* <div className="bell-icon" onClick={onClickBellHandler} /> */}
        <div className={is_logged ? 'd-none' : 'd-block'}>
          <LanguageSelector />
        </div>
      </nav>
    </header>
  )

  const mobile_form = (
    <>
      {(show_mobile_ad && show_banner) && <div className="header-mobile-app-banner">
        {/* Close button */}
        <div onClick={() => set_show_mobile_ad(false)} className="banner-left">
            <Image  className={ClassNames(is_mobile ? 'd-block' : 'd-none') + 'pointer-none'} src={close_icon} fluid />
        </div>
        <div className="banner-center">
          <Image src={itas_app_icon} height={40} />
          <span className="banner-text">
            <p>ITAS<br />{t("banner_mobile_app.insurances_title")}</p>
          </span>
        </div>
        <div className="banner-right">
          <Button
            target="Registrazione"
            classes={get_language() === 'IT' ? 'gtm-login' : 'p-1 de-button'}
            name="full_862633"
            onClick={handleAppDownloadUri}
          >
            <div className="pointer-none">{t("banner_mobile_app.label_cta")}</div>
            <div className={ClassNames(get_language() === 'IT' ? 'right-arrow-white' : 'right-arrow-white-de')} />
          </Button>
        </div>
      </div>}
      <header className="header-navbar">
        <div className="header-logo">
          <a href="https://www.gruppoitas.it/">
            <Image
              src={get_language() === 'IT' ? itas_assicurazioni_it : itas_assicurazioni_de}
              width={128}
              height={40}
            />
          </a>
        </div>
        <nav className="header-nav">
          <div>
            <LanguageSelector />
          </div>
          {/* <div className="bell-icon" onClick={onClickBellHandler} /> */}
          {/* {is_logged ? <div className="side-drawer-icon" onClick={show_mobile_menu_handler} /> : null} */}
          {is_logged && (
            <div
              className="
            row py-1 pl-md-4 pr-md-2"
              onClick={show_mobile_menu_handler}
            >
              <div className="icon-person row align-items-center c-ffffff mr-2">
                <div className="w-100 text-center">
                  {customer?.personTypeCode === 'F'
                    ? `${customer?.name?.charAt(0)}${customer?.surname?.charAt(0)}`
                    : customer?.businessName?.substring(0, 2)}
                </div>
              </div>
              <div className="dropdown_icon--bottom filter-7f7f7f" />
            </div>
          )}
        </nav>
      </header>
    </>
  )

  return (
    <div className="position-relative">
      {!is_mobile && process.env.REACT_APP_ENV !== 'PRD' && <Version />}
      {is_mobile ? mobile_form : desktop_form}
      {mobile_menu_visible && (
        <MobileMenu
          title={
            customer?.personTypeCode === 'F' ? customer?.name || '' : customer?.businessName || ''
          }
          proclie={customer?.proClie || ''}
          show={mobile_menu_visible}
          menu_items={header_data.menu_items}
          closed={show_mobile_menu_handler}
          on_click_item_handler={dropdown_item_handler}
        />
      )}
    </div>
  )
}

export default Header
